import { render, staticRenderFns } from "./EsgCarbonEmissionExpectedPurchaseCost.vue?vue&type=template&id=4a699e9e"
import script from "./EsgCarbonEmissionExpectedPurchaseCost.vue?vue&type=script&lang=js"
export * from "./EsgCarbonEmissionExpectedPurchaseCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports